import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/callback/stripe/setup')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/callback/stripe/setup"!</div>
}
